import { action, mutator, orchestrator } from 'satcheljs';
import getAppHostStore from '../store/appHostStore';
import { log } from '../utils/telemetry';
import type AppHostViewState from '../store/schema/AppHostViewState';
import type { MailboxInfo } from 'owa-client-types';
import { getLogAppId } from 'owa-m365-acquisitions/lib/utils/getLogAppId';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export type OpenMetaOsAppAction = {
    viewState: AppHostViewState;
    mailboxInfo?: MailboxInfo;
};

/* Do not call this action directly, use utils/openLaunchPageMetaOsApp instead */
export interface OnOpenMetaOsAppActionMessage {
    viewState: AppHostViewState;
    mailboxInfo: MailboxInfo | undefined;
}
const onOpenMetaOsApp: ({
    viewState,
    mailboxInfo,
}: OpenMetaOsAppAction) => OnOpenMetaOsAppActionMessage = action(
    'onOpenMetaOsApp',
    ({ viewState, mailboxInfo }: OpenMetaOsAppAction): OnOpenMetaOsAppActionMessage => ({
        viewState,
        mailboxInfo,
    })
);

mutator(onOpenMetaOsApp, (actionMessage: OpenMetaOsAppAction) => {
    let { viewState } = actionMessage;

    // save viewstate to store
    getAppHostStore().viewStates.set(viewState.appHostId, viewState);
    viewState = getAppHostStore().viewStates.get(viewState.appHostId) ?? viewState;

    // save primary app host id to store
    getAppHostStore().primaryAppHostId = viewState.appHostId;

    const { appDefinition } = viewState;
    if (!appDefinition || !appDefinition.staticTabs || appDefinition.staticTabs.length === 0) {
        viewState.isInError = true;
    }
});

orchestrator(onOpenMetaOsApp, async actionMessage => {
    const { viewState, mailboxInfo } = actionMessage;
    const { appDefinition, callerFn, subEntityId } = viewState;
    const appId = appDefinition?.id ?? '';
    const hasSubEntityId = !!subEntityId;
    const logAppId = await getLogAppId(appId);
    const logData = {
        callerFn,
        hasSubEntityId,
        appId: logAppId,
    };
    const resolvedMailboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();
    log(logData, resolvedMailboxInfo);
});

export default onOpenMetaOsApp;
